'use client';

import type { ChatMentionsMenuItemType } from '@terra/ui-design-system';
import { BodyDefault, Dialog } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import { useChatStore } from '../../store/chatStore';

export type SelectHttpContextForChatDialogState = {
  requestMention: ChatMentionsMenuItemType;
  responseMention: ChatMentionsMenuItemType;
};

type SelectHttpContextForChatDialogProps = {
  state: SelectHttpContextForChatDialogState | null;
  onClose: () => void;
};

export function SelectHttpContextForChatDialog({
  state,
  onClose,
}: SelectHttpContextForChatDialogProps) {
  const t = useTranslations('chat.httpContextDialog');
  const sendHttpMentionsToChat = useChatStore(
    (store) => store.sendHttpMentionsToChat,
  );

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        onClose();
      }
    },
    [onClose],
  );

  const sendMentions = useCallback(
    (mentions: ChatMentionsMenuItemType[]) => {
      sendHttpMentionsToChat({ mentions });
      onClose();
    },
    [onClose, sendHttpMentionsToChat],
  );

  if (!state) {
    return null;
  }

  return (
    <Dialog
      open
      onOpenChange={handleOpenChange}
      size="sm"
      title={t('title')}
      secondaryAction={{
        label: t('requestOnly'),
        onClick: () => sendMentions([state.requestMention]),
      }}
      primaryAction={{
        label: t('requestAndResponse'),
        onClick: () =>
          sendMentions([state.requestMention, state.responseMention]),
      }}
    >
      <BodyDefault color="fg.muted">{t('description')}</BodyDefault>
    </Dialog>
  );
}
